module.exports = __webpack_public_path__ + "img/body-3.3a1f5647.png";